import type { CMSData, CMSSection, ServiceItem, TestimonialItem } from '../types/cms';

export function getDesktopField(data: CMSData, section: CMSSection, field: string): string {
  const block = data[section] as Record<string, unknown>;
  const v = block?.[field];
  return typeof v === 'string' ? v : '';
}

export function getMobileFieldRaw(
  data: CMSData,
  section: CMSSection,
  field: string
): string | undefined {
  const mobile = data.mobile?.[section] as Record<string, unknown> | undefined;
  if (!mobile || !Object.prototype.hasOwnProperty.call(mobile, field)) return undefined;
  const v = mobile[field];
  return typeof v === 'string' ? v : undefined;
}

/** Texto efectivo: en móvil usa override si existe; si no, el de escritorio. */
export function getEffectiveField(
  data: CMSData,
  section: CMSSection,
  field: string,
  useMobile: boolean
): string {
  if (!useMobile) return getDesktopField(data, section, field);
  const m = getMobileFieldRaw(data, section, field);
  if (m !== undefined) return m;
  return getDesktopField(data, section, field);
}

export function getEffectiveImageUrl(
  images: Record<string, string>,
  baseKey: string,
  useMobile: boolean,
  fallback = ''
): string {
  const desktop = images[baseKey] ?? fallback;
  if (!useMobile) return desktop || fallback;
  const mobileKey = `${baseKey}_mobile`;
  const m = images[mobileKey];
  return m && m.length > 0 ? m : desktop || fallback;
}

export function mobileImageKey(baseKey: string): string {
  return `${baseKey}_mobile`;
}

export function getEffectiveServiceItem(
  data: CMSData,
  id: string,
  useMobile: boolean
): ServiceItem | undefined {
  const base = data.services.items.find((s) => s.id === id);
  if (!base) return undefined;
  if (!useMobile) return base;
  const patch = data.mobile?.services?.items?.[id];
  if (!patch) return base;
  return { ...base, ...patch };
}

export function getEffectiveTestimonialItem(
  data: CMSData,
  id: string,
  useMobile: boolean
): TestimonialItem | undefined {
  const base = data.testimonials.items.find((t) => t.id === id);
  if (!base) return undefined;
  if (!useMobile) return base;
  const patch = data.mobile?.testimonials?.items?.[id];
  if (!patch) return base;
  return { ...base, ...patch };
}
